import { ServiceResponse } from '@sdbn/common';
import { TransportWeighing } from './../model/transport-weighing';
import { AppServerAPI } from '@sdbn/common';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Identity } from '@sdbn/common';

@Injectable({
  providedIn: 'root'
})
export class WeighTransportService {

  constructor(private appServerAPI: AppServerAPI) { }

  public getTransportWeighings(transportIdentity: Identity): Observable<TransportWeighing[]> {
    return this.appServerAPI.execute('/client/control/weighing/weighings', transportIdentity);
  }

  public createWeighing(weighing: TransportWeighing): Observable<ServiceResponse> {
    return this.appServerAPI.execute('/client/control/weighing/create', weighing);
  }

  public createPrintout(transportIdentity: Identity) {

    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'weighing-printout');

    // keep focus in current window
    window.focus();

    const url = `/client/control/weighing/printout`;
    this.appServerAPI.postWithArraybufferResponse<any>(url, transportIdentity).subscribe(result => {

      const file = new Blob([result], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }

    }, error => {
      console.error(error);
    });
  }
}
